export enum ResourceStatus {
    ACTIVE = 'ACTIVE',
    OBSOLETE = 'OBSOLETE',
}